<template>
    <div>
        <b-button :href="$api_url+'/employee/attendance/import/template'" v-if="flag != 1"><b-icon icon="code-slash" ></b-icon> Template For This Month</b-button>
        <b-button :href="$api_url+'/employee/attendance/import/template?flg=1'" v-if="flag != 1"><b-icon icon="code-slash" ></b-icon> Template For Today</b-button>
        <b-button v-if="flag != 1" @click="importAttendances"><b-icon icon="box-arrow-up" class="" scale="1"></b-icon> Import</b-button>
        
        <b-modal id="bv-modal-import-attendance" scrollable  hide-footer title="Import Attendance">
            <b-overlay :show="showoverlay" rounded="sm" class="">
                <b-form-file id="datafile" name="datafile" @change="uploadFile"  accept=".xlsx,.xls"></b-form-file>
                <!--<b-button type="button" v-if="has_file" @click="checkFileData" variant="primary" size="lg">Validate file data</b-button>
                <b-button type="button" v-if="has_file" @click="processFileData" variant="primary" size="lg">Process file data</b-button>-->
                
                
                <div v-if='errormsg'>
                    <div v-if="errormsg.length > 0" class="alert alert-danger my-3">Total error {{errormsg.length}}</div>
                    <ul class="list-group ">           
                        <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
                    </ul>
                </div>
            </b-overlay>
        </b-modal>
  </div>
</template>
<script>

    export default{
        
        mounted() {
            
        },
        props: ['flg'],
        data(){            
            
            return {
                flag : this.flg,
                ce : true,
                empfile : null,
                has_file : false,
                errormsg : [],
                showoverlay : false,
                show_employee_list : false,
                people : 0,
                blankmsg : 'Fetching data..',

                upload_url : '',
                process_url : '',

                successmsg : false,
                warningmsg : false,
                dangermsg : false,
      
            }
        },
        methods:{
            
            setUrls:function()
            {
                this.upload_url = this.$api_url+"/employee/attendance/import";
                this.process_url = this.$api_url+'/employee/attendance/import/process';               

            },
            
            uploadFile:function(event) 
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;                
                this.errormsg = [];
                // this function upload the logo
                this.empfile = event.target.files[0];

                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                axios.post(this.upload_url, data , config).
                    then(function (response){

                        this.has_file = true;
                         
                        this.$bvToast.toast('Processing the data feed file.', {
                                            title: `Job on progress`,
                                            variant: 'info',
                                            solid: true
                                        });                        
                    
                        this.showoverlay = false;
                        this.processFileData();
                        
                    }.bind(this)).
                    catch(function (error) 
                            {
                                //alert(error.response.data.errors);
                            });
            },
            processFileData:function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                this.errormsg = [];
                axios.get(this.process_url)
                .then(function (response) {                
                        
                        if(response.data.status)
                        {                            
                            this.$bvToast.toast('Data feed file successfully imported', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                        this.$bvModal.hide('bv-modal-import-leave');

                            setTimeout(function () {location.reload();  }.bind(this), 1000);          
                        }
                        else
                        {
                            this.errormsg = response.data.errors;
                        }

                    this.showoverlay = false;    
                        
                }.bind(this)).catch(function (error){
                    
                    //currentObj.serverError(error);
                    currentObj.showoverlay = false;  
                    currentObj.$bvToast.toast('Please correct the data and try again.', {
                                            title: `Data Template Error`,
                                            variant: 'danger',
                                            solid: true
                                        });
                    
                }); ;
            },
            
            // Added by sohel
            importAttendances: function()
            {
                this.$bvModal.show('bv-modal-import-attendance');
            },

            
        },
        created: function(){
            this.setUrls();
            
        },
    }
</script>